import type { QueryClient } from "@tanstack/react-query";
import { affiliateEarningsKeys } from "Api/Queries/Lead/useAffiliateEarningsQuery";
import { affiliateLinkKeys } from "Api/Queries/Lead/useGetAffiliateLink";
import { leadListKeys } from "Api/Queries/Lead/useGetLeadListQuery";
import { userInfoKeys } from "Auth/Api/Queries/useUserInfoQuery";

/**
 * Everything a Díky Tobě participation change can alter (ZS-1623): the state itself (user-info, read
 * by every consumer), the invitation link (closed outside the program), the lead lists and the
 * earnings (a refusal or an opt-out cuts referrals).
 */
export const invalidateThanksToYouQueries = (queryClient: QueryClient) =>
  Promise.all([
    queryClient.invalidateQueries({ queryKey: userInfoKeys.all }),
    queryClient.invalidateQueries({ queryKey: affiliateLinkKeys.all }),
    queryClient.invalidateQueries({ queryKey: leadListKeys.all }),
    queryClient.invalidateQueries({ queryKey: affiliateEarningsKeys.all }),
  ]);
